var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5C5C5C",
    viewBox: "0 0 14 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.378 24.036A2.14 2.14 0 0 0 14 22.52a2.16 2.16 0 0 0-.622-1.515l-8.249-8.34 8.25-8.34a2.14 2.14 0 0 0 .62-1.515 2.16 2.16 0 0 0-.62-1.515 2.12 2.12 0 0 0-1.5-.628 2.1 2.1 0 0 0-1.498.628L.62 11.16A2.14 2.14 0 0 0 0 12.676a2.16 2.16 0 0 0 .622 1.515l9.759 9.866c.807.817 2.168.817 2.997-.021"
  })));
};
export default SvgChevronLeft;